import { Typography } from '@mui/material';
import { hasOnlyStockPhotos } from 'careit';
import { useTranslation } from 'react-i18next';

// Shown when a donation's only photos were copied from an inventory item (#609).
export default function StockPhotoDisclaimer({ images, ...props }) {
  const { t } = useTranslation('translation');
  if (!hasOnlyStockPhotos(images)) return null;
  return (
    <Typography variant="caption" color="text.secondary" {...props}>
      {t('donations.stock-photo-disclaimer')}
    </Typography>
  );
}
